// eslint-disable-next-line import/no-unused-modules
export default function intToHexString(d: number | null, padding: number) {
  let hex = Number(d).toString(16);
  while (hex.length < padding) {
    hex = `0${hex}`;
  }
  return `0x${hex}`;
}
